const SETUPS = [
  'The scorecard has requested witness protection',
  'Your pencil is refusing further comment',
  'That ball has retained legal counsel',
  'The group behind just ordered dinner',
  'Your caddie has updated their CV',
  'The flag is pretending it never saw you',
  'That was less golf, more guided tour',
  'The GPS has marked this as an unsolved mystery',
  'Your putter would like a transfer',
  'The handicap committee felt a disturbance',
  'That hole now has its own documentary',
  'The scorecard ran out of emotional support',
  'Your ball visited every local attraction',
  'The gallery has entered a period of silence',
  'That swing came with deleted scenes',
  'The bunker is charging you rent',
  'Your playing partners have formed a support group',
  'The pin has stopped taking this personally',
  'That score needs its own postal code',
  'The round has officially become character building',
] as const;

const COURSE_PUNCHLINES = [
  (course: string) => `${course} would like its ball back.`,
  (course: string) => `the clubhouse at ${course} heard that one.`,
  (course: string) => `${course} has opened an incident report.`,
  (course: string) => `even the ducks at ${course} looked away.`,
  (course: string) => `order something cold at ${course}.`,
] as const;

const courseSeed = (course: string) =>
  course.split('').reduce((total, character) => total + character.charCodeAt(0), 0);

/**
 * Produces 100 stable course-aware combinations. The stroke offset changes the
 * setup as well as the punchline, so adjacent score buttons never show the
 * same joke on a hole. Moving to the next hole rotates the set too.
 */
export const blowUpCommentary = (course: string, hole: number, strokes: number) => {
  const safeCourse = course.trim() || 'the course';
  const index = (courseSeed(safeCourse) + ((hole - 1) * COURSE_PUNCHLINES.length) + Math.abs(strokes) * 19) % 100;
  const setup = SETUPS[Math.floor(index / COURSE_PUNCHLINES.length)];
  const punchline = COURSE_PUNCHLINES[index % COURSE_PUNCHLINES.length](safeCourse);
  return `${setup} — ${punchline}`;
};
